exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-somos[data-v-97707a7e]{margin-top:50px;margin-bottom:50px}.is-horizontal-center[data-v-97707a7e]{display:flex!important;justify-content:center}#logoDucter[data-v-97707a7e]{max-width:300px;height:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-97707a7e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/landing_Componentes/Somos.vue
// module id = 1569
// module chunks = 0